import NPCustomSlideAuthStrategy from './AuthStrategies/NPCustomSlideAuthStrategy.js';
import DefaultAuthStrategy from './AuthStrategies/DefaultAuthStrategy.js';
import NPTokenAuthStrategy from './AuthStrategies/NPTokenAuthStrategy.js';
import DefaultErrorNormalizationStrategy from './ErrorNormalizationStrategies/DefaultErrorNormalizationStrategy.js';

const authStrategiesMap = {
  DEFAULT: DefaultAuthStrategy,
  NP_TOKEN: NPTokenAuthStrategy,
  NP_CUSTOM_SLIDE: NPCustomSlideAuthStrategy
  // Add more auth strategies here
};
const errorStrategiesMap = {
  DEFAULT: DefaultErrorNormalizationStrategy
  // Add more error normalization strategies here
};

// Add the types for the strategies config here with an union type

export { authStrategiesMap, errorStrategiesMap };
//# sourceMappingURL=index.js.map
